import { Component, Input, OnInit, OnDestroy, AfterViewInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';
import { MenuItem } from 'primeng/api';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { CompaniesContactsSelectPage as ContactsSelectPage } from 'src/app/modals/companies-contacts-select/companies-contacts-select.page';
import { SelectPage as TeamMembersSelectPage } from 'src/app/team-members/select/select.page';
import { SelectComponent as TagsSelectPage } from 'src/app/components/tags/select/select.component';
import { ManagerComponent as GroupsManagerPage } from 'src/app/components/groups/manager/manager.component';
import { CreatePage as ClientGroupCreatePage } from '../clients/groups/create/create.page';
import * as dayjs from 'dayjs';
import { DetailsPage as ClientDetailsPage } from 'src/app/clients/details/details.page';
import { DetailsPage as ProjectDetailsPage } from 'src/app/projects/details/details.page';
import { DetailsPage as TaskDetailsPage } from 'src/app/tasks/details/details.page';
import { DetailsPage as StepDetailsPage } from 'src/app/steps/details/details.page';
import { DetailsPage as EmailDetailsPage } from 'src/app/secure-email/details/details.page';
import { CustomFieldsService, CustomFieldDef } from 'src/app/api/custom-fields.service';
import { ManageComponent as ManageCustomFieldsComponent } from 'src/app/components/custom-fields/manage/manage.component';

@Component({
  selector: 'app-details',
  templateUrl: './details.page.html',
  styleUrls: ['./details.page.scss'],
})
export class DetailsPage implements OnInit {

  @ViewChild('commentsTable') commentsTable: any;
  @ViewChild('topRowRef', { static: false }) topRowRef: ElementRef | undefined;
  @ViewChild('footerRowRef', { static: false }) footerRowRef: ElementRef | undefined;
  @ViewChild('navRowRef', { static: false }) navRowRef: ElementRef | undefined;
  comment_max_size = 0;
  comment_filter: string = 'Company';
  all_company_comments: any[] = [];
  company_direct_comments: any[] = [];
  company_project_comments: any[] = [];
  company_task_comments: any[] = [];
  company_step_comments: any[] = [];
  company_missing_info_comments: any[] = [];
  company_secure_email_comments: any[] = [];
  comments_loading: boolean = false;
  active_reply_guid: string = null;
  reply_comment: any = { reply_to: null, reply_to_text: null, reply_to_name: null, comment: '', update: false };
  total_comment_count: number = 0;

  edit_mode = false;
  details_edit_mode = false;
  @Input() company = {
    guid: '',
    name: '',
    description: '',
    phone_number: '',
    fax: '',
    website: '',
    str_address_1: '',
    str_address_2: '',
    city: '',
    province: '',
    postal_code: '',
    country: '',
    clients: [],
    tags: [],
    team_members: [],
    comments: [],
    files: [],
    groups: [],
    client_groups: [],
    projects: [],
    corp_name: '',
    custom_id: '',
    business_number: '',
    industry: '',
    type: '',
    default_client_guid: '',
    folder: [],
    is_a_client: false,
    all_team_members: false,
    year_end_month: '',
    year_end_day: '',
    year_end_date: '2025-01-01',
        custom_data: '',
    custom_data_arr: [],
    deleted: false,
  }
  company_copy: any;
  // Current firm-wide company field definitions (Manage Firm > Companies), refreshed by
  // MergeFirmCustomFields() - used by IsGlobalField() to lock the type dropdown on a field that
  // came from (or now matches) the global list, since letting one company retype it would
  // disagree with what every other company/dynamic-data consumer expects that field to be.
  firmFieldDefs: CustomFieldDef[] = [];

  company_basic_info: any = {};

  unassigned_users = [];
  unassigned_team_members = [];
  activeIndex = 'overview';
  // Opened from an @mention notification: the comment to scroll to and highlight on the Comments tab
  @Input() focus_comment: any = null;
  // Opens the details on this tab (e.g. 'todos' from the To Do list's client link)
  @Input() start_tab = '';
  todo_status: 'open' | 'completed' | 'all' = 'open';
  team_member_roles = [];
  clients_roles = [];
  availableDays: number[] = [];



  constructor(
    private apiService: ApiService,
    private modalController: ModalController,
    public globalService: GlobalService,
    private alertController: AlertController,
    private customFieldsService: CustomFieldsService
  ) { }

  ngOnInit() {
    if (this.start_tab) this.activeIndex = this.start_tab;
    this.GetData();
  }


  GetCommentsSize() {
      const el = this.topRowRef.nativeElement as HTMLElement;
      const rect = el.getBoundingClientRect();
      const footerEl = this.footerRowRef.nativeElement as HTMLElement;
      const footerRect = footerEl.getBoundingClientRect();
      const navEl = this.navRowRef.nativeElement as HTMLElement;
      const navRect = navEl.getBoundingClientRect();
      let allowed_size = Math.round(rect.height) - (Math.round(footerRect.height) + Math.round(navRect.height));
      this.comment_max_size = allowed_size-1;
      console.log("Allowed Size:", allowed_size);
      return allowed_size - 1;
  }


  //ORDER IS IMPORTANT
  async GetData() {
    await this.globalService.presentLoading("", 999999);
    await this.GetRoles();
    await this.GetCompanyDetails();
    this.company_copy = JSON.stringify(this.company);
    this.globalService.dismissLoading();
  }
  async GetCompanyDetails() {
    this.company.default_client_guid = '';
    let data: any = await this.apiService.get(`companies/${this.company.guid}`);
    if (data.success) {
      console.log("Company", data.data[0]);
      this.company = data.data[0];
      //make the object cleaner
      if (!this.company.clients) this.company.clients = [];
      if (!this.company.team_members) this.company.team_members = [];
      if (!this.company.tags) this.company.tags = [];
      if (!this.company.comments) this.company.comments = [];
      if (!this.company.files) this.company.files = [];
      if (!this.company.projects) this.company.projects = [];
      if (!this.company.groups) this.company.groups = [];
      if (!this.company.client_groups) this.company.client_groups = [];
      
      // Parse year_end_date to populate month and day fields
      if (this.company.year_end_date) {
        const yearEndDate = dayjs(this.company.year_end_date);
        this.company.year_end_month = yearEndDate.format('MM');
        this.company.year_end_day = yearEndDate.format('DD');
        this.updateAvailableDays(); // Populate day options based on month
      }

      {
        let parsed: any = this.company.custom_data;
        for (let i = 0; i < 2 && typeof parsed === 'string' && parsed; i++) {
          try { parsed = JSON.parse(parsed); } catch (e) { parsed = []; }
        }
        this.company.custom_data_arr = Array.isArray(parsed) ? parsed : [];
      }
      await this.MergeFirmCustomFields();
      

      
      this.ClientsFormat();
      console.log("Team Members", this.company.team_members);
      this.TeamMembersFormat();
      //Make a copy of the company for editing basic info
      this.company_basic_info = this.globalService.CopyBasicInfo(this.company);
      // Snapshot the MERGED array (post-MergeFirmCustomFields), not the raw pre-merge
      // this.company.custom_data string - CancelUpdate() below parses this back into
      // custom_data_arr on Cancel, and GoToStep() calls CancelUpdate() on every tab switch, so
      // snapshotting the pre-merge data here was wiping the firm-wide fields back out the moment
      // you navigated to (or off of) any tab.
      this.company_basic_info.custom_data = JSON.stringify(this.company.custom_data_arr);

      console.log("Company: ", this.company);
      if (this.activeIndex === 'comments') this.GetAllCompanyComments();
    }
  }

  ClientsFormat() {
    if (this.company.clients) {
      //Loop through each client and assign their company role name
      this.company.clients.forEach(client => {
        let role = this.clients_roles[this.globalService.GetArrayIndex(this.clients_roles, client.role_guid)];
        if (role) client.company_role_name = role.title;
        if (client.guid == this.company.default_client_guid) client.background_highlight = '#7FFF00';
        else client.background_highlight = null;
      });
    }
  }

  TeamMembersFormat() {
    if (this.company.team_members) {
      //Loop through each team member and assign their company role name
      this.company.team_members.forEach(team_member => {
        let role = this.team_member_roles[this.globalService.GetArrayIndex(this.team_member_roles, team_member.role_guid)];
        console.log("Role", role);
        if (role) team_member.company_role_name = role.title;
      });
    }
  }


  async GetRoles() {
    await this.GetTeamRoles();
    await this.GetClientsRoles();
  }

  //Return the list of team member roles
  async GetTeamRoles() {
    let data: any = await this.apiService.get('firms/team_members/roles');
    if (data.success) {
      this.team_member_roles = data.data;
    }
  }
  //Return the list of roles for clients
  async GetClientsRoles() {
    let data: any = await this.apiService.GetRoles();
    if (data.success) {
      this.clients_roles = data.data;
    }
  }

  async Close() {
    if (!(await this.ConfirmDiscardEdits())) return;
    if (this.edit_mode || this.details_edit_mode) await this.CancelUpdate();
    this.modalController.dismiss(this.company);
  }

  // One edit mode for the whole company (the Edit in the footer)
  StartEdit() {
    if (!this.globalService.Can('companies_update')) return;
    this.edit_mode = true;
    this.details_edit_mode = true;
  }

  // Asks before leaving (another tab, or closing) while editing - leaving undoes the changes that aren't saved yet
  private async ConfirmDiscardEdits(): Promise<boolean> {
    if (!this.edit_mode && !this.details_edit_mode) return true;
    return new Promise<boolean>(async resolve => {
      const alert = await this.alertController.create({
        header: 'Unsaved Changes',
        message: 'You are editing this company. Leaving will undo your changes until you click Save.',
        backdropDismiss: false,
        buttons: [
          { text: 'Discard Changes', role: 'destructive', handler: () => resolve(true) },
                    { text: 'Keep Editing', role: 'cancel', handler: () => resolve(false) }
        ]
      });
      await alert.present();
    });
  }

  //Change steps
  async GoToStep(val) {
    if (val != this.activeIndex) {
      if (!(await this.ConfirmDiscardEdits())) return;
      if (this.edit_mode || this.details_edit_mode) await this.CancelUpdate();
    }
    this.activeIndex = val;
    if (val == 'comments') {
      this.GetAllCompanyComments();
    }
  }

  async GetAllCompanyComments() {
    this.comments_loading = true;

    this.company_direct_comments = [];
    this.company_project_comments = [];
    this.company_task_comments = [];
    this.company_step_comments = [];
    this.company_missing_info_comments = [];
    this.company_secure_email_comments = [];

    const result: any = await this.apiService.get(`companies/${this.company.guid}/all_comments`);
    if (result.success && result.data) {
      const formatComment = (c: any) => {
        const f = { ...c };
        if (f.users && typeof f.users === 'string') f.users = JSON.parse(f.users);
        return f;
      };
      for (const c of result.data.map(formatComment)) {
        if (c.source_type === 'company') this.company_direct_comments.push(c);
        else if (c.source_type === 'project') this.company_project_comments.push(c);
        else if (c.source_type === 'task') this.company_task_comments.push(c);
        else if (c.source_type === 'step') this.company_step_comments.push(c);
        else if (c.source_type === 'missing_info') this.company_missing_info_comments.push(c);
        else if (c.source_type === 'secure_email') this.company_secure_email_comments.push(c);
      }
      this.company.comments = [...this.company_direct_comments];
    }

    this.all_company_comments = [
      ...this.company_direct_comments,
      ...this.company_project_comments,
      ...this.company_task_comments,
      ...this.company_step_comments,
      ...this.company_missing_info_comments,
      ...this.company_secure_email_comments,
    ];
    this.total_comment_count = this.all_company_comments.length;
    this.comments_loading = false;
  }

  async OpenCommentSource(comment: any) {
    const componentMap: any = {
      project: ProjectDetailsPage,
      task: TaskDetailsPage,
      step: StepDetailsPage,
      secure_email: EmailDetailsPage,
    };
    const component = componentMap[comment.source_type];
    if (!component) return;
    const modal = await this.modalController.create({
      component,
      cssClass: 'large-modal',
      componentProps: { guid: comment.source_guid },
      backdropDismiss: false,
    });
    await modal.present();
  }

  GetFilteredCompanyComments() {
    if (this.comment_filter === 'Project') return this.company_project_comments;
    if (this.comment_filter === 'Task') return this.company_task_comments;
    if (this.comment_filter === 'Actions') return this.company_step_comments;
    if (this.comment_filter === 'Missing Information') return this.company_missing_info_comments;
    if (this.comment_filter === 'Secure Email') return this.company_secure_email_comments;
    return this.all_company_comments;
  }

  SetCompanyCommentFilter(filter: string) {
    this.comment_filter = filter;
    this.CancelInlineReply();
  }

  StartInlineReply(comment: any) {
    this.active_reply_guid = comment.guid;
    this.reply_comment = {
      reply_to: comment.guid,
      reply_to_text: comment.comment,
      reply_to_name: comment.users?.[0]?.display_name,
      comment: '',
      update: false
    };
  }

  CancelInlineReply() {
    this.active_reply_guid = null;
    this.reply_comment = { reply_to: null, reply_to_text: null, reply_to_name: null, comment: '', update: false };
  }

  async SubmitInlineReply(comment: any) {
    let url = 'companies/comments';
    let guid = this.company.guid;
    if (comment.source_type === 'project') { url = 'projects/comments'; guid = comment.source_guid; }
    else if (comment.source_type === 'task') { url = 'tasks/comments'; guid = comment.source_guid; }
    else if (comment.source_type === 'step') { url = 'steps/comments'; guid = comment.source_guid; }
    else if (comment.source_type === 'missing_info') { url = 'missing_info/comments'; guid = comment.source_guid; }
    else if (comment.source_type === 'secure_email') { url = 'secure_email/comments'; guid = comment.source_guid; }

    const data: any = await this.apiService.post(`${url}/${guid}`, this.reply_comment);
    if (data.success) {
      const current_user = this.globalService.GetCurrentUser();
      const new_comment: any = data.data[0];
      new_comment.users = [{ display_name: current_user.display_name, guid: current_user.guid }];
      new_comment.comment = JSON.parse(JSON.stringify(this.reply_comment.comment));
      new_comment.reply_to_guid = this.reply_comment.reply_to;
      new_comment.source_type = comment.source_type;
      new_comment.source_title = comment.source_title;
      new_comment.source_guid = comment.source_guid;

      if (comment.source_type === 'project') this.company_project_comments.unshift(new_comment);
      else if (comment.source_type === 'task') this.company_task_comments.unshift(new_comment);
      else if (comment.source_type === 'step') this.company_step_comments.unshift(new_comment);
      else if (comment.source_type === 'missing_info') this.company_missing_info_comments.unshift(new_comment);
      else if (comment.source_type === 'secure_email') this.company_secure_email_comments.unshift(new_comment);
      else { this.company_direct_comments.unshift(new_comment); if (this.company.comments) this.company.comments.unshift(new_comment); }

      this.all_company_comments.unshift(new_comment);
      this.total_comment_count = this.all_company_comments.length;
      this.CancelInlineReply();
    }
    this.globalService.presentToastMessage(data.message, data.success);
  }


  //Google API logic
  //Sets the company address automatically
  handleAddressChange(address: Address) {
    this.company.str_address_1 = address.formatted_address;
    this.company.city = address.address_components.filter(f => JSON.stringify(f.types) === JSON.stringify(['locality', 'political']))[0].long_name;
    this.company.province = address.address_components.filter(f => JSON.stringify(f.types) === JSON.stringify(['administrative_area_level_1', 'political']))[0].long_name;
    this.company.country = address.address_components.filter(f => JSON.stringify(f.types) === JSON.stringify(['country', 'political']))[0].long_name;
    this.company.postal_code = address.address_components.filter(f => JSON.stringify(f.types) === JSON.stringify(['postal_code']))[0].long_name;
  }

  //Returns the text value of the employee type
  //Returns the text value of the employee type
  GetEmployeeTypeText(guid) {
    let i = this.team_member_roles.findIndex(item => item.guid === guid);
    if (i == -1)
      return "No Role";
    else
      return this.team_member_roles[i].title;
  }
  //Returns the colour of the employee tpe
  GetEmployeeTypeColour(guid) {
    let i = this.team_member_roles.findIndex(item => item.guid === guid);
    if (i == -1)
      return "#ADD8E6";
    else
      return this.team_member_roles[i].colour;
  }

  //Returns the text value of the employee type
  GetClientTypeText(guid) {
    let i = this.clients_roles.findIndex(item => item.guid === guid);
    if (i == -1)
      return "No Role";
    else
      return this.clients_roles[i].title;
  }
  //Returns the colour of the employee tpe
  GetClientTypeColour(guid) {
    let i = this.clients_roles.findIndex(item => item.guid === guid);
    if (i == -1)
      return "light-blue";
    else
      return this.clients_roles[i].colour;
  }

  // Assigned contacts grouped under a heading per role, so the badges are easier to scan than one
  // long flat list - "No Role" is always last, everything else alphabetical by role title.
  get clientsByRole(): { role_guid: string; title: string; colour: string; clients: any[] }[] {
    if (!this.company.clients || this.company.clients.length === 0) return [];
    const groups: { role_guid: string; title: string; colour: string; clients: any[] }[] = [];
    for (const client of this.company.clients) {
      const role_guid = client.role_guid || '';
      let group = groups.find(g => g.role_guid === role_guid);
      if (!group) {
        group = { role_guid, title: this.GetClientTypeText(role_guid), colour: this.GetClientTypeColour(role_guid), clients: [] };
        groups.push(group);
      }
      group.clients.push(client);
    }
    groups.sort((a, b) => a.role_guid === '' ? 1 : b.role_guid === '' ? -1 : a.title.localeCompare(b.title));
    return groups;
  }

  // The role groups without the default contact (they are pinned above, so they are only listed once) - and roles left with nobody
  // aren't shown
  get contactGroups(): { role_guid: string; title: string; colour: string; clients: any[] }[] {
    const pinned = this.defaultContactRow?.client;
    return this.clientsByRole
      .map(group => ({ ...group, clients: group.clients.filter(c => c !== pinned) }))
      .filter(group => group.clients.length > 0);
  }

  // The company's default contact, pinned above the role groups
  get defaultContactRow(): { client: any; role_title: string; role_colour: string } | null {
    for (const group of this.clientsByRole) {
      const client = group.clients.find(c => c.guid === this.company.default_client_guid);
      if (client) return { client, role_title: group.title, role_colour: group.colour };
    }
    return null;
  }

  // Roles collapsed on the Overview tab's contact list - all expanded to begin with
  collapsed_contact_roles = new Set<string>();
  ToggleContactRole(role_guid: string) {
    if (this.collapsed_contact_roles.has(role_guid)) this.collapsed_contact_roles.delete(role_guid);
    else this.collapsed_contact_roles.add(role_guid);
  }


  //Prompt to select clients
  async presentSelectClientsModal() {
    let company_clients_copy = JSON.stringify(this.company.clients);
    const modal = await this.modalController.create({
      component: ContactsSelectPage,
      cssClass: 'small-modal tall-modal secondary-modal',
      backdropDismiss: true,
      componentProps: {
        company: this.company,
        selecting_for_company: true,
        selecting_for_default: true,
        default_client_guid: this.company.default_client_guid,
        hide_companies: true,
        selected_clients: this.company.clients,
        remove_clients: this.company.clients,
        in_clients: [],
        target_header: 'Currently Selected'
      }
    })
    modal.onDidDismiss().then(async (data: any) => {
      if (data && data.data.clients) {
        company_clients_copy = JSON.parse(company_clients_copy);
        await this.CheckCompanyClients(company_clients_copy, data.data.clients);
      }
      else {
        this.company.clients = [...JSON.parse(company_clients_copy)];
      }
      this.ClientsFormat();

    });
    return await modal.present()
  }

  //See if we have to remove or add tags
  async CheckCompanyClients(old_clients, new_clients) {
    const old_default_guid = old_clients.default_client_guid;
    console.log("old default guid");
    await this.globalService.presentLoading("Updating Contacts", 999999);
    let added = false;
    //Check to see if all the old clients still exist, if not we will run a delete statement to the api
    for (let i = 0; i < old_clients.length; i++) {
      const client = old_clients[i];
      const index = new_clients.findIndex(e => client.guid === e.guid);
      if (index == -1) {
        console.log(client);
        await this.RemoveClient(client);
      }
    }
    //If the old client does not exist in the new clients, run api statement to add it
    for (let i = 0; i < new_clients.length; i++) {
      const client = new_clients[i];
      if(client.default_for_company) {
        if(client.guid != old_default_guid) {
          this.company.default_client_guid = client.guid;
          let data: any = await this.apiService.put(`companies/${this.company.guid}`, {default_client_guid: this.company.default_client_guid});
          console.log("Set Default Client Response", data);
        }
      }
      const index = old_clients.findIndex(e => client.guid === e.guid);
      if (index == -1) {
        added = true;
        await this.AddClient(client);
      }
    }
    //Loop through and see what clients have been changed
    for (let i = 0; i < new_clients.length; i++) {
      const client = new_clients[i];
      const index = old_clients.findIndex(e => client.guid === e.guid);
      if (index >= 0) {
        if (JSON.stringify(client) != JSON.stringify(old_clients[index])) {
          added = true;
          await this.UpdateClient(client)
        }
      }
    }
    this.globalService.dismissLoading();
    if (added) this.GetCompanyDetails();

  }

  async RemoveClient(client) {
    let data: any = await this.apiService.delete(`companies/clients/${this.company.guid}`, client);

  }
  async AddClient(client) {
    let data: any = await this.apiService.post(`companies/clients/${this.company.guid}`, client);
  }
  async UpdateClient(client) {
    let data: any = await this.apiService.put(`companies/clients/${this.company.guid}`, client);
  }


  //select team members and add them to the companies team members
  async presentSelectTeamMembersModal() {
    let company_team_members_copy = JSON.stringify(this.company.team_members);
    console.log("Company Team Members", this.company.team_members);
    const modal = await this.modalController.create({
      component: TeamMembersSelectPage,
      cssClass: 'small-modal tall-modal secondary-modal',
      backdropDismiss: true,
      componentProps: {
        company: this.company,
        selecting_for_company: true,
        selected_team_members: this.company.team_members,
        remove_team_members: this.company.team_members,
        in_team_members: [],
        target_header: 'Currently Selected'
      }
    })
    modal.onDidDismiss().then((data: any) => {
      if (data && data.data) {
        company_team_members_copy = JSON.parse(company_team_members_copy);
        this.CheckCompanyTeamMembers(company_team_members_copy, data.data);
      }
      else {
        this.company.team_members = [...JSON.parse(company_team_members_copy)];
      }

    });
    return await modal.present()
  }

  //See if we have to remove or add tags
  async CheckCompanyTeamMembers(old_team_members, new_team_members) {
    await this.globalService.presentLoading("Updating Team Members", 999999);
    //Check to see if all the old team_members still exist, if not we will run a delete statement to the api
    old_team_members.forEach(team_member => {
      const index = new_team_members.findIndex(e => team_member.guid === e.guid);
      if (index == -1) {
        this.RemoveTeamMember(team_member);
      }
    });
    //If the old client does not exist in the new team_members, run api statement to add it
    new_team_members.forEach(team_member => {
      const index = old_team_members.findIndex(e => team_member.guid === e.guid);
      if (index == -1) {
        this.AddTeamMember(team_member);
      }
    });
    //Loop through and see what clients have been changed
    new_team_members.forEach(team_member => {
      const index = old_team_members.findIndex(e => team_member.guid === e.guid);
      if (index >= 0) {
        if (JSON.stringify(team_member) != JSON.stringify(old_team_members[index])) {
          this.UpdateTeamMember(team_member)
        }
      }
    });
    this.globalService.dismissLoading();
  }

  async RemoveTeamMember(team_member) {
    let data: any = await this.apiService.delete(`companies/team_members/${this.company.guid}`, team_member);

  }
  async AddTeamMember(team_member) {
    let data: any = await this.apiService.post(`companies/team_members/${this.company.guid}`, team_member);
  }
  async UpdateTeamMember(team_member) {
    let data: any = await this.apiService.put(`companies/team_members/${this.company.guid}`, team_member);
  }


  //When they are trying to update the basic information about the company
  async CancelUpdate() {
    this.edit_mode = false;
    this.details_edit_mode = false;
    this.globalService.RestoreBasicInfo(this.company_basic_info, this.company);
    this.company.custom_data_arr = JSON.parse(this.company_basic_info.custom_data);
  }

  async UpdateBasicInfo() {
    // Asks about any field added via addField() this edit session before saving - see
    // CustomFieldsService.PromptAndSaveNewFieldScopes.
    this.firmFieldDefs = await this.customFieldsService.PromptAndSaveNewFieldScopes('companies', this.company.custom_data_arr);
    this.customFieldsService.AssignFieldIds(this.company.custom_data_arr);
    this.company.custom_data = JSON.stringify(this.company.custom_data_arr);
    let data: any = await this.apiService.put(`companies/${this.company.guid}`, this.company);

    if (data.success) {
      this.company_basic_info = this.globalService.CopyBasicInfo(this.company);
      this.company_basic_info.custom_data = this.company.custom_data;
      this.ClientsFormat();
      this.edit_mode = false;
      this.details_edit_mode = false;
    }

  }

  //TAGS
  //Present the modal to select tags to apply to the company
  async presentSelectTagsModal() {
    let company_tags_copy = JSON.stringify(this.company.tags);
    const modal = await this.modalController.create({
      component: TagsSelectPage,
      cssClass: 'small-modal tall-modal secondary-modal',
      backdropDismiss: true,
      componentProps: {
        url: 'companies',
        selected_tags: this.company.tags
      }
    })
    modal.onDidDismiss().then((data: any) => {

      if (data && data.data) {
        company_tags_copy = JSON.parse(company_tags_copy);
        this.CheckCompanyTags(company_tags_copy, data.data);
      }
      else {
        this.company.tags = [...JSON.parse(company_tags_copy)];
      }
    });
    return await modal.present()
  }

  //See if we have to remove or add tags
  async CheckCompanyTags(old_tags, new_tags) {
    await this.globalService.presentLoading("Updating Tags", 999999);
    //Check to see if all the old tags still exist, if not we will run a delete statement to the api
    old_tags.forEach(tag => {
      const index = new_tags.findIndex(e => tag.guid === e.guid);
      if (index == -1) {
        console.log(tag);
        this.RemoveTag(tag);
      }
    });
    //If the old tag does not exist in the new tags, run api statement to add it
    new_tags.forEach(tag => {
      const index = old_tags.findIndex(e => tag.guid === e.guid);
      if (index == -1) {
        console.log("ADD");
        this.AddTag(tag);
      }
    });
    this.globalService.dismissLoading();
  }
  async RemoveTag(tag) {
    let data: any = await this.apiService.delete(`companies/tags/${this.company.guid}`, tag);
  }
  async AddTag(tag) {
    let data: any = await this.apiService.post(`companies/tags/${this.company.guid}`, tag);
  }


  //COMPANY GROUPS
  async presentSelectGroupsModal() {
    let company_groups_copy = JSON.stringify(this.company.groups);
    const modal = await this.modalController.create({
      component: GroupsManagerPage,
      cssClass: 'medium-modal tall-modal secondary-modal',
      backdropDismiss: true,
      componentProps: {
        url: 'companies',
        selection_mode: true,
        max_selection: 999,
        selected_groups: [...this.company.groups],
        modal_title: 'Select Groups'
      }
    });
    modal.onDidDismiss().then((data: any) => {
      console.log("data",data);
      if (data && data.data) {
        company_groups_copy = JSON.parse(company_groups_copy);
        this.CheckCompanyGroups(company_groups_copy, data.data);
      }
    });
    return await modal.present();
  }

  //See if we have to remove or add groups
  async CheckCompanyGroups(old_groups, new_groups) {
    await this.globalService.presentLoading("Updating Groups", 999999);
    //Check to see if all the old groups still exist, if not we will run a delete statement to the api
    old_groups.forEach(group => {
      const index = new_groups.findIndex(e => group.guid === e.guid);
      if (index == -1) {
        console.log(group);
        this.RemoveGroup(group);
      }
    });
    //If the old group does not exist in the new groups, run api statement to add it
    new_groups.forEach(group => {
      const index = old_groups.findIndex(e => group.guid === e.guid);
      if (index == -1) {
        console.log("ADD");
        this.AddGroup(group);
      }
    });
    this.company.groups = [...new_groups];
    this.globalService.dismissLoading();
  }
  async RemoveGroup(group) {
    let data: any = await this.apiService.delete(`groups/companies/${this.company.guid}`, group);
  }
  async AddGroup(group) {
    let data: any = await this.apiService.post(`groups/companies/${this.company.guid}`, group);
  }


  //Create groups of companies
  async presentCreateClientGroupModal() {
    const modal = await this.modalController.create({
      component: ClientGroupCreatePage,
      cssClass: 'small-modal tall-modal secondary-modal',
      backdropDismiss: false,
      componentProps: {
        company: this.company
      }
    })
    modal.onDidDismiss().then((data: any) => {
      if (data && data.data && data.data[0]) {
        console.log(data.data);
        this.company.client_groups = [...this.company.client_groups, data.data[0]];
      }

    });
    return await modal.present()
  }

  async presentEditClientGroupModal(group) {
    const modal = await this.modalController.create({
      component: ClientGroupCreatePage,
      cssClass: 'small-modal tall-modal secondary-modal',
      backdropDismiss: false,
      componentProps: {
        company: this.company,
        group: group,
        edit_mode: true
      }
    })
    modal.onDidDismiss().then((data: any) => {
      console.log("Dismiss Edit");
      console.log(data);
      if (data && data.data) {
        console.log(data.data);
        this.company.client_groups[this.company.client_groups.findIndex(item => item.guid === data.data.guid)] = data.data;
      }

    });
    return await modal.present()
  }

  async ChangeAllowAllTeamMembers() {
    console.log("Change Allow All Team Members, " , this.company.all_team_members);
    let post_data = {
      all_team_members: this.company.all_team_members
    }
    let data: any = await this.apiService.put(`companies/${this.company.guid}`, post_data);
  }

  updateAvailableDays() {
    if (!this.company.year_end_month) {
      this.availableDays = [];
      return;
    }

    const month = parseInt(this.company.year_end_month, 10);
    const currentYear = new Date().getFullYear();
    
    // Get the number of days in the selected month
    // Using current year to determine leap year status
    const daysInMonth = new Date(currentYear, month, 0).getDate();
    
    // Generate array from 1 to daysInMonth
    this.availableDays = Array.from({ length: daysInMonth }, (_, i) => i + 1);
    
    // Update year_end_date when month changes
    this.updateYearEndDate();
  }

  updateYearEndDate() {
    if (!this.company.year_end_month || !this.company.year_end_day) {
      return;
    }

    const currentYear = new Date().getFullYear();
    const month = this.company.year_end_month.padStart(2, '0');
    const day = this.company.year_end_day.padStart(2, '0');
    
    this.company.year_end_date = `${currentYear}-${month}-${day}`;
  }


  // Firm-wide custom field definitions (Manage Firm > Companies) that this company doesn't
  // already have by name get added here with a blank value - see CustomFieldsService.MergeFieldDefsInto.
  async MergeFirmCustomFields() {
    const defs = await this.customFieldsService.GetFieldDefs();
    this.firmFieldDefs = defs.companies;
    this.customFieldsService.MergeFieldDefsInto(this.company.custom_data_arr, defs.companies, defs.loaded, defs.deleted_companies);
  }
  // Custom tab (view mode): only fields that have a value, unless "Show Empty Custom Fields" is on.
  // Checkbox fields always show, ticked or not.
  show_empty_custom_fields = false;

  VisibleCustomFields(): any[] {
    const fields: any[] = this.company?.custom_data_arr || [];
    if (this.show_empty_custom_fields) return fields;
    return fields.filter((field: any) => {
      if (field?.type === 'checkbox') return true;
      const value = field?.value;
      return value !== null && value !== undefined && !(typeof value === 'string' && value.trim() === '');
    });
  }


  IsGlobalField(field: any): boolean {
    return this.firmFieldDefs?.some(d => d.name === field.name) ?? false;
  }

  async OpenManageGlobalCustomFields() {
    const modal = await this.modalController.create({
      component: ManageCustomFieldsComponent,
      cssClass: 'tall-modal medium-modal secondary-modal',
      backdropDismiss: false,
      componentProps: { entity_type: 'companies' },
    });
    modal.onDidDismiss().then(async (data: any) => {
      if (data?.data?.saved) await this.MergeFirmCustomFields();
    });
    return await modal.present();
  }

  addField() {
  this.company.custom_data_arr.push({
    name: '',
    type: 'text',
    value: '',
    _is_new: true
  });
}

removeField(index: number) {
  this.company.custom_data_arr.splice(index, 1);
}


async DeleteCompany() {
    const alert = await this.alertController.create({
      header: 'Delete Company',
      message: `Are you sure you want to delete <strong>${this.company.name}</strong>? This will delete all related projects, tasks, and steps. This action cannot be undone.`,
      buttons: [
        { text: 'Cancel', role: 'cancel' },
        {
          text: 'Delete',
          cssClass: 'alert-button-danger',
          handler: async () => {
            await this.globalService.presentLoading('Deleting company...', 9000000);
            const data: any = await this.apiService.delete(`companies/${this.company.guid}`, {});
            this.globalService.dismissLoading();
            if (data.success) {
              this.globalService.presentToastMessage(data.message, true);
              this.company.deleted = true;
              this.Close();
            } else {
              this.globalService.presentToastMessage(data.message, false);
            }

          }
        }
      ]
    });
    await alert.present();
  }

  async PresentClientDetails(client) {
    const modal = await this.modalController.create({
      component: ClientDetailsPage,
      cssClass: 'large-modal',
      componentProps: {
        client: client
      },
      backdropDismiss: false

    })
    modal.onDidDismiss().then((data: any) => {
      console.log("Dismiss Data: ", data);
      if (data.data) {
        //@TODO figure out how to update the client name
        // client = data.data;
        // this.ClientsFormat();
      }
    });
    return await modal.present()
  }


}
